"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.set.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.regexp.to-string.js");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _isChildOfType = require("../_utils/isChildOfType");
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _CollapsePanel = _interopRequireDefault(require("./CollapsePanel"));
var _excluded = ["id", "onClick", "disabled"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Collapse = function Collapse(props) {
  var className = props.className,
    style = props.style,
    destroyInactivePanel = props.destroyInactivePanel,
    openId = props.openId,
    onChange = props.onChange,
    defaultOpenId = props.defaultOpenId,
    children = props.children,
    iconAni = props.iconAni;
  // 替代值
  var _onChange = function _onChange() {};
  var _useState = (0, _react.useState)(openId === undefined ? defaultOpenId : openId),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    _openId = _useState2[0],
    setOpenId = _useState2[1];

  // 非受控模式下，使用内部状态
  if (openId === undefined) {
    _onChange = function _onChange(evt, item) {
      var isTab = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var tempOpenId = null;
      if (item.id !== _openId) {
        tempOpenId = item.id;
      }
      setOpenId(tempOpenId);
      if (typeof onChange === 'function') {
        onChange(evt, item, isTab);
      }
    };
  } else {
    _onChange = onChange;
  }
  var panelRenderedSetRef = (0, _react.useRef)(new Set());
  (0, _react.useEffect)(function () {
    if (openId === undefined || openId === _openId) {
      setOpenId('');
      return;
    }
    setOpenId(openId);
  }, [openId]);
  function getPanels() {
    var panelRenderedSet = panelRenderedSetRef.current;
    var panelChildren = [];
    _react.default.Children.forEach(children, function (child, index) {
      if ((0, _isChildOfType.isChildOfType)(child, _CollapsePanel.default)) {
        var _props = child.props,
          key = child.key;
        var id = _props.id,
          onClick = _props.onClick,
          disabled = _props.disabled,
          extraPops = (0, _objectWithoutProperties2.default)(_props, _excluded);
        var open = _openId === _props.id;
        var _onClick = function _onClick(evt, item) {
          if (typeof onClick === 'function') {
            onClick(evt, item);
          }
          if (typeof _onChange === 'function') {
            _onChange(evt, item, false);
          }
        };
        if (open && !panelRenderedSet.has(_openId)) {
          panelRenderedSet.add(_openId);
        }
        if (child.props.forceRender || destroyInactivePanel && open || !destroyInactivePanel && panelRenderedSet.has(_props.id)) {
          panelChildren.push( /*#__PURE__*/_react.default.cloneElement(child, {
            key: key !== null && key !== 'null' ? key : id,
            open: open,
            // onClick: !disabled ? _onClick : () => {},
            onClick: _onClick
          }));
        } else {
          delete extraPops.children;
          panelChildren.push( /*#__PURE__*/_react.default.createElement(_CollapsePanel.default, (0, _extends2.default)({
            id: id,
            key: key !== null && key !== 'null' ? key : id,
            open: open,
            disabled: disabled,
            onClick: !disabled ? _onClick : function () {}
          }, extraPops)));
        }
      } else if ( /*#__PURE__*/_react.default.isValidElement(child)) {
        panelChildren.push( /*#__PURE__*/_react.default.cloneElement(child, {
          key: index.toString()
        }));
      } else {
        panelChildren.push( /*#__PURE__*/_react.default.createElement("div", {
          key: index.toString()
        }, child));
      }
    });
    return panelChildren;
  }
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('collapse');
  var classes = (0, _classnames2.default)(prefixCls, className, (0, _defineProperty2.default)({}, "".concat(prefixCls, "--ani"), !!iconAni));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style
  }, getPanels());
};
Collapse.defaultProps = {
  destroyInactivePanel: true
};
var _default = exports.default = Collapse;